import {WAR_PHASE_STAGES} from "../../constants/phases";

export const getWarPhaseStageIcon = (warStage) => {
  const stageIcons = {
    [WAR_PHASE_STAGES.RECRUITMENT]: '/img/icons/coins white.png',
    [WAR_PHASE_STAGES.MOVEMENT]: '/img/icons/speed white.png',
    [WAR_PHASE_STAGES.ABILITIES]: '/img/icons/ability_white.png',
    [WAR_PHASE_STAGES.SHOOTING]: '/img/icons/shooting white.png',
    [WAR_PHASE_STAGES.COMBAT]: '/img/icons/barracks white.png',
    [WAR_PHASE_STAGES.MANEUVER]: '/img/icons/maneuver.png',
  };
  return stageIcons[warStage] || warStage;
};